import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IntlMessages from "util/IntlMessages";
import ImageUploader from 'react-images-upload';
import CircularProgress from "@material-ui/core/CircularProgress";


const UploadImagesDialog = ({open, handleClose, title, saving=false, single=false, maxWidth='sm'}) => {
    const [pictures, setPictures] = React.useState([]);

    const onDrop = (pictureFiles, pictureDataURLs) => {
        setPictures(pictureFiles);
    }


    return (
        <Dialog
            fullWidth
            open={open}
            // onClose={handleClose(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
            <DialogContent>
                <ImageUploader
                    withIcon={true}
                    buttonText='Chọn hình'
                    onChange={onDrop}
                    imgExtension={['.jpg', '.gif', '.png', '.gif', '.jpeg']}
                    maxFileSize={5242880}
                    withPreview={true}
                    singleImage={single}
                />
            </DialogContent>
            <DialogActions>
                <div className='position-relative'>

                    <Button onClick={() => handleClose(true, pictures)} color="primary" disabled={saving}>
                        <IntlMessages id='ok'/>
                    </Button>
                    {saving && <CircularProgress size={24} className='position-absolute text-primary'/>}
                </div>
                <Button onClick={() => handleClose(false, [])} color="warning" autoFocus disabled={saving}>
                    <IntlMessages id='cancel'/>
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default UploadImagesDialog
